// src/components/editors/EnumEditor.tsx
import {
  Button,
  Icons,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@commenda/kakashi';
import { PrimitiveType, TPrimitiveValue, TSchemaObject } from '@commenda/types';
import { useState } from 'react';

export const EnumEditor = ({
  schemaObject,
  onChange,
}: {
  schemaObject: TSchemaObject;
  onChange: (so: TSchemaObject) => void;
}) => {
  const [input, setInput] = useState('');
  const values = schemaObject.enumValues ?? [];

  return (
    <div className="flex items-top gap-2">
      <div className="w-32">
        <Select
          value={schemaObject.enumBase ?? PrimitiveType.STRING}
          onValueChange={(val: PrimitiveType) =>
            onChange({ ...schemaObject, enumBase: val })
          }
        >
          <SelectTrigger className="text-text-secondary txt-small-regular">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="text-text-secondary txt-small-regular">
            {[PrimitiveType.STRING, PrimitiveType.NUMBER].map((pt) => (
              <SelectItem key={pt} value={pt}>
                {pt}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <Input
        className="text-text-secondary txt-small-regular !px-3.5 !py-2.5"
        placeholder="Add value and press Enter"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && input.trim()) {
            let val: TPrimitiveValue = input.trim();
            if (schemaObject.enumBase === PrimitiveType.NUMBER)
              val = Number(val);
            if (schemaObject.enumBase === PrimitiveType.BOOLEAN)
              val = val === 'true';
            onChange({ ...schemaObject, enumValues: [...values, val] });
            setInput('');
          }
        }}
      />

      <div className="flex gap-1 flex-wrap">
        {values.map((val, idx) => (
          <div
            className="flex items-center bg-white rounded-md"
            key={String(val)}
          >
            <Input
              value={String(val)}
              readOnly
              className="border-none text-text-secondary txt-small-regular !px-3.5 !py-2.5"
            />
            <Button
              variant="tertiary"
              size="sm"
              onClick={() => {
                const next = values.slice();
                next.splice(idx, 1);
                onChange({ ...schemaObject, enumValues: next });
              }}
            >
              <Icons.X className="size-4" />
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};
